import { Box, Button, Heading, Text, useStyleConfig } from '@chakra-ui/react';
import { FaDownload } from 'react-icons/fa';
import { download, downloadCoverLetter, onLink } from '../../../handlers';
import React from 'react';


const Header = ({ props }) => {
  const stateProps = props.stateProps;
  const sectionName = stateProps.sectionData.sectionName;
  const navSection = props.navSections[sectionName];
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  return (
    <Box width="70%" margin="0 auto" paddingBottom="16px" display="flex" justifyContent="space-between">
      <Box>

        <Box>
          <Heading>Cover Letter Preview</Heading>
        </Box>
        <Box>
          <Text>You can edit the text directly below, or download the Word document.</Text>
        </Box>
      </Box>
    </Box>
  );

};
export default Header;
/*
<Heading variant="sectionHeading">Preview</Heading>
          <ProTip proTip={navSection.instructions} variant="section" stateProps={stateProps} />

          <Box display="flex" justify-content="flex-end">
            <Link href="https://rshelp.paperform.co" target="_blank"><RiInformationFill
              fontSize="24px" /></Link>
          </Box>
 */